import { Component } from 'react';
import { Container, Row, Col } from "reactstrap";
import { connect } from 'react-redux';
import Stepper from 'react-stepper-horizontal';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Main from '../../layout/main';
import RgisterPersonal from "../../components/register/register-personal";
import RegisterOtpVerification from "../../components/register/register-otp-verification";
import { registerPersonal, clearRegisterPersonalError } from '../../redux/actions/registerpersonal';
import { registerOtp, clearRegisterOtpError } from '../../redux/actions/register-otp';
import { storeBusiness } from '../../redux/actions/storeBusiness';
import { getServiceTypes } from "../../redux/actions/serviceList";
import { registerBussiness } from "../../redux/actions/registerBusiness";
import { registerAdditional } from "../../redux/actions/registerAdditional";
import { getRefarralList } from "../../redux/actions/refarralList";
import { socialSignup } from "../../redux/actions/socialSignup";
import API from '../../API';
import axios from 'axios';
import history from '../../common/history';
import { setAuth } from '../../utils';
import { login } from '../../redux/actions/login';
class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepsCompleted: 0,
            personalData: {},
            phone: "",
            otpError: "",
            signupCredentials: null, // Store signup credentials for auto-login
            steps: [
                {
                    title: "Personal",
                    onClick: (e) => {
                        e.preventDefault();
                    }
                },
                {
                    title: "Verification",
                    onClick: (e) => {
                        e.preventDefault();
                    }
                }
            ],
            // currentStep: 0,
        };
    }
    componentDidMount() {
        // Clear any existing registration errors when component mounts
        this.props.clearRegisterPersonalError();
        this.props.clearRegisterOtpError();
        this.props.getServiceTypes();
        this.props.getRefarralList();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    componentDidUpdate(prevProps) {
        // Check if OTP verification was successful
        if (prevProps.regOtpData.loading && !this.props.regOtpData.loading && 
            this.props.regOtpData.registration && this.props.regOtpData.completedRegsteps) {
            // OTP verification successful, perform auto-login
            this.performAutoLogin();
        }
        
        // Check if OTP verification failed
        if (prevProps.regOtpData.loading && !this.props.regOtpData.loading && 
            this.props.regOtpData.error) {
            // Set OTP error in state to display it
            this.setState({ otpError: this.props.regOtpData.error });
        }
    }

    handleRegisterPersonal = (data) => {
        // Store signup credentials for auto-login after successful OTP verification
        this.setState({
            signupCredentials: {
                email: data.email,
                password: data.password,
                user_type: "3"
            }
        });
        
        const inputData = JSON.stringify({
            sign_up: {
                first_name: data.firstName,
                last_name: data.lastName,
                email: data.email,
                mobile_number: data.phone,
                password: data.password,
                password_confirmation: data.confirmPassword,
                user_type: "3",
                referral_ids: data.referral_id,
                sms_notifications: data.enableSMS,
            }
        });
        this.props.registerPersonal(inputData);
    }
    handeleOtpVerification = (data, confirmation_token) => {
        if (data == "") {
            this.setState({ otpError: "Enter the OTP" })
        } else if (data.length < 6) {
            this.setState({ otpError: "Enter 6 digit OTP" })
        } else {
            this.setState({ otpError: "" })
        }
        if (this.state.otpError == "") {
            const inputData = JSON.stringify({
                confirmation_token: confirmation_token,
                otp: data
            });
            // Use Redux action for OTP verification
            this.props.registerOtp(inputData);
        }
    }
    
    performAutoLogin = () => {
        const { signupCredentials } = this.state;
        if (signupCredentials) {
            // Use Redux action to perform auto-login
            this.props.login(signupCredentials);
        } else {
            // Fallback to login page if no credentials stored
            window.location.href = "/login";
        }
    }
    
    handleBack = () => {
        // Go back to the previous page in browser history
        history.goBack();
    }
    
    clearOtpError = () => {
        this.setState({ otpError: "" });
    }
    
    handleRegisterVerification = (data) => {
        const verifData = JSON.stringify({
            provider: {
                auth_token: data.auth_token,
                have_insurance: data.insuranceid != "",
                have_license: data.licenceid != "",
                insurance_number: data.insuranceid,
                license_number: data.licenceid,
                google_id: data.googleid,
                yelp_id: data.yelpid,
                referral_ids: data.referral_id
            }
        })
        this.props.registerAdditional(verifData)
    }
    render() {
        const { steps } = this.state;
        const { activeRegistrationStep } = this.props;
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EasyBids - Home Improvements ::  Registration</title>
                    <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
                </Helmet>
                <Main additionalClass_main="register">
                    <section className="ebw-section__pages">
                        <Container fluid={true} className="ebw__entry">
                            <Row className="ebw-entry__row">
                                <Col sm="12" md="7" xl="5" className="ebw-entry__col mx-auto text-center">
                                    <div className="ebw-entry__content-rgt position-relative">
                                        <h2 className="ebw-entry__register-title">Register</h2>
                                        <div className="ebw-entry__register-flow position-relative d-flex flex-column mx-auto justify-content-center">
                                            <ul className="ebw-entry__register-list position-relative d-flex justify-content-between align-items-center mb-6">
                                                <Stepper
                                                    steps={steps}
                                                    activeStep={activeRegistrationStep.activeRegistrationStep - 1}
                                                    completeBarColor="#1875FB"
                                                    defaultColor="#EAEDFF"
                                                    defaultTitleColor="#373737"
                                                />
                                            </ul>
                                            {activeRegistrationStep.activeRegistrationStep === 1 &&
                                                <RgisterPersonal handleRegisterPersonal={this.handleRegisterPersonal} />}

                                            {activeRegistrationStep.activeRegistrationStep === 2 &&
                                                <RegisterOtpVerification
                                                    otpError={this.state.otpError}
                                                    buttonName="Verify"
                                                    mobileNumber={this.state.personalData.mobile_number && this.state.personalData.mobile_number}
                                                    handeleOtpVerification={this.handeleOtpVerification}
                                                    onBack={this.handleBack}
                                                    onOtpErrorClear={this.clearOtpError}
                                                />}


                                            <div className="ebw-entry__other-options">
                                                <div className="mb-3">
                                                    <span className="ebw-entry__other-account">Already have an account?</span>
                                                    <Link to="/login" className="ebw-entry__other-create ml-1">Login</Link>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </Main>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    regPersonaldata: state.registerPersonal,
    regOtpData: state.registerOtp,
    BussData: state.storeBusiness,
    serviceTypesData: state.serviceTypes,
    activeRegistrationStep: state.registrationStep,
    refarralList: state.refarralList,

});
export default connect(mapStateToProps, {
    registerPersonal, clearRegisterPersonalError, registerOtp, clearRegisterOtpError, storeBusiness, getServiceTypes, registerBussiness, registerAdditional, getRefarralList, socialSignup, login
})(Register);